import React from 'react';
import { Img, Text, Button, Icon } from '../../Atoms';
import { Input, Modal } from '../../Molecules';
import notifTel from '../../assets/img/notifTel.png';

function ModalConfirmpassword (props) {
  return (
    <Modal
      show={props.show}
      showIconClose={false}
      centered={true}
      onHide={() => props.onHide()}
      contentClassName={
        'content-modal-confirm-password' + props.contentClassName
      }
    >
      {props.modalStep === 1 && (
        <div className='full-container'>
          <Icon
            icon='BigX'
            className='icon-close-modal-confim-password'
            size='20px'
            onClick={() => props.onHide()}
          />
          <Text text={props.title} className='title-modal-confirm-password' />
          <Text
            text={props.firstText}
            className='text-description-confirm-password'
          />
          <Text
            text={props.secondText}
            className='text-description-confirm-password'
          />
          <div className='container-center'>
            <Input
              classNameContainer='container-input-confirm-change'
              className={props.classNameInput}
              placeholder='tapez le code ici'
              onChange={props.onChange}
              value={props.code}
            />
          </div>
          <div className='container-center'>
            <Button
              text='Valider'
              className={`${props.classNameBtnSubmit} web-display-none`}
              onClick={props.onConfirmCode}
            />
            <Button
              text='Confirmer le code'
              className={`${props.classNameBtnSubmit} mob-display-none`}
              onClick={props.onConfirmCode}
            />
          </div>
          <div className='container-center'>
            <Button
              type='primary'
              text='Annuler'
              className={props.classNameBtncancel}
              onClick={props.onCancel}
            />
          </div>
        </div>
      )}
      {props.modalStep === 2 && (
        <div className='full-container'>
          <Icon
            icon='BigX'
            className='icon-close-modal-confim-password'
            size='20px'
            onClick={() => props.onHide()}
          />
          <Text
            text={props.successText}
            className='title-modal-confirm-password'
          />
          <div className='container-center'>
            <Img
              src={props.img}
              className='img-success object-fit object-fit'
            />
          </div>
          <div
            className='container-center title-web-hidden'
            style={{ marginTop: '22px' }}
          >
            <Button
              type='primary'
              text='Fermer'
              className={props.classNameBtncancel}
              onClick={props.onCancel}
            />
          </div>
        </div>
      )}
    </Modal>
  );
}
ModalConfirmpassword.defaultProps = {
  img: notifTel,
  contentClassName: '',
  modalStep: 1,
  title: '',
  firstText: '',
  secondText: '',
  onConfirmCode: null,
  onCancel: null,
  classNameBtncancel: 'btn-cancel-confirm-password',
  classNameBtnSubmit: 'btn-submit-confirm-password',
  classNameInput: 'input-confirm-change',
  onChange: null,
  code: ''
};
export default ModalConfirmpassword;
